import React from 'react';
import PropTypes from 'prop-types';
import { Grid, GridItem, Title, TitleSizes } from '@patternfly/react-core';

import Undrafted from './Undrafted';

function UndraftedPositions(props) {
  const fields = ['tier', 'name', 'team', 'bye_week'];

  return (
    <div id="undrafted-positions">
      <Title headingLevel="h1" size={TitleSizes.lg}>
        Beersheets Top Picks By Position
      </Title>
      <Grid hasGutter>
        <GridItem span={6}>
          <Title headingLevel="h2" size={TitleSizes.md}>
            Runningbacks
          </Title>
          <Undrafted fields={fields} players={props.players} draft={(p) => props.draft(p)} size={15} position="RB" />
        </GridItem>
        <GridItem span={6}>
          <Title headingLevel="h2" size={TitleSizes.md}>
            Wide Recievers
          </Title>
          <Undrafted fields={fields} players={props.players} draft={(p) => props.draft(p)} size={15} position="WR" />
        </GridItem>
        <GridItem span={6}>
          <Title headingLevel="h2" size={TitleSizes.md}>
            Quarterbacks
          </Title>
          <Undrafted fields={fields} players={props.players} draft={(p) => props.draft(p)} size={15} position="QB" />
        </GridItem>
        <GridItem span={6}>
          <Title headingLevel="h2" size={TitleSizes.md}>
            Tightends
          </Title>
          <Undrafted fields={fields} players={props.players} draft={(p) => props.draft(p)} size={15} position="TE" />
        </GridItem>
      </Grid>
    </div>
  );
}

UndraftedPositions.propTypes = {
  draft: PropTypes.func.isRequired,
  players: PropTypes.array.isRequired,
};

export default UndraftedPositions;
